import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    const locale = matched[1]
    messages[locale] = locales(key)
  })

  return messages
}

function getBrowserLocale() {
  const language = navigator.language || navigator.userLanguage
  // Detect if the browser language is Spanish or a variant
  return language.startsWith('es') ? 'es' : 'en'
}

export default new VueI18n({
  locale: getBrowserLocale(),
  fallbackLocale: 'en', // Optional: fallback in case no language file matches
  messages: loadLocaleMessages(),
})
